import React, { Component } from 'react';

import { mergeStyles } from '@Sage/ssm-utils';

import ForceManagerTheme from './themes/ForceManagerTheme';

export const withStyles = (styles) => (DecoratedComponent) => (props) => {
    const newStyles = mergeStyles(styles(ForceManagerTheme), props.styles);
    return <DecoratedComponent {...props} ref={props.reference} styles={newStyles} />;
};
